import { render } from "./LibraryRightClickBox.vue?vue&type=template&id=4786576a&scoped=true"
import script from "./LibraryRightClickBox.vue?vue&type=script&lang=js"
export * from "./LibraryRightClickBox.vue?vue&type=script&lang=js"

import "./LibraryRightClickBox.vue?vue&type=style&index=0&id=4786576a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4786576a"]])

export default __exports__